import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getBaseUrl } from '../../environment';

function configureAxiosGlobalSettings(): void {
    axios.defaults.baseURL = getBaseUrl();
}

export function createAxiosInstance(): AxiosInstance {
    configureAxiosGlobalSettings();

    const configuration: AxiosRequestConfig = {};

    configuration.baseURL = getBaseUrl();

    return axios.create(configuration);
}
